var map = {
	"./alert.png": "zZEU",
	"./arrow_right.png": "LGnP",
	"./b1_on.png": "JjDJ",
	"./b2.png": "TGLZ",
	"./b2_on.png": "PHrU",
	"./b3.png": "6E2S",
	"./b3_on.png": "w5Oa",
	"./b4.png": "v8NB",
	"./b4_on.png": "F/QS",
	"./b8.png": "/Zh8",
	"./b81.png": "WvG+",
	"./b8_on.png": "EF4M",
	"./bdstk.png": "Nxr0",
	"./bind.png": "OK72",
	"./close.png": "/TeD",
	"./del2.png": "FS/5",
	"./edit.png": "KObk",
	"./empty.png": "Bm30",
	"./error.mp3": "LKKg",
	"./fail.png": "3XzQ",
	"./fail_1.png": "WN4x",
	"./fkm.png": "nsEu",
	"./hb.png": "mi1j",
	"./icon_refresh_loading01@2x.png": "ucQK",
	"./icon_refresh_loading02@2x.png": "edjL",
	"./jfgk.png": "S/i7",
	"./jn_off.png": "6nNK",
	"./jn_on.png": "z/Jw",
	"./jymx.png": "oB/A",
	"./kb.png": "CQt9",
	"./lb_w.png": "IQtr",
	"./loading2.gif": "si/C",
	"./logo.png": "iQH9",
	"./lpk.png": "MIJT",
	"./marker.png": "35vI",
	"./order_peisong.png": "t+RA",
	"./order_peisong_on.png": "8TPD",
	"./order_wait_pay.png": "tj42",
	"./order_wait_pay_on.png": "IZi4",
	"./order_wait_peisong.png": "wuxW",
	"./order_wait_peisong_on.png": "BAGn",
	"./order_wait_pingjia.png": "NjbL",
	"./order_wait_pingjia_on.png": "pGqC",
	"./order_wait_refund.png": "VsZD",
	"./order_wait_refund_on.png": "tTjO",
	"./over.mp3": "j7Vp",
	"./pay.png": "321P",
	"./phone.png": "JhOT",
	"./play.png": "VZWR",
	"./qr.png": "NZYh",
	"./red_bg.png": "1dx6",
	"./red_envelope.png": "TBOH",
	"./red_envelope_bg.png": "LZ33",
	"./red_envelope_bottom.png": "hMiN",
	"./red_envelope_logo.png": "cF5y",
	"./reduce3.png": "b15u",
	"./refresh.gif": "8o9/",
	"./right.png": "SuS5",
	"./scan.png": "7k9H",
	"./select.png": "GEq8",
	"./select2.png": "lI9H",
	"./star0.png": "XZG8",
	"./star1.png": "3tBu",
	"./star2.png": "5lGV",
	"./start.mp3": "uCXh",
	"./success.mp3": "HHeA",
	"./success.png": "4AGf",
	"./temp/1.jpg": "t85V",
	"./temp/2.jpg": "PEbK",
	"./temp/3.jpg": "ltpL",
	"./temp/4.jpg": "rOAw",
	"./temp/5.jpg": "yunN",
	"./temp/bar.png": "DmcK",
	"./temp/card.jpg": "sUPu",
	"./temp/qr.png": "GDYt",
	"./time.png": "L7xM",
	"./uni.ttf": "VwHn",
	"./unknown.mp3": "3ZCR",
	"./v4.png": "ItSa",
	"./v8.png": "XO8P",
	"./v9.png": "B2Fj",
	"./warn.png": "LkBP",
	"./zfmm.png": "qeUb",
	"./zk.png": "qQ1q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1